export default "__VITE_ASSET__C2sy8K4S__"